import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CustomWidgetData} from "../../types/custom-widgets/custom-widget-data";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AddCustomWidgetService} from "../../services/custom-widgets/add-custom-widget.service";
import {UserRole} from "../../types/userrole/user-role";
import {SystemType} from "../../types/common/system-type";
import {SelectItem} from "primeng/api";
import {UserRolesRestService} from "../../services/userrole/user-roles-rest.service";
import {Subscription} from "rxjs";
import {FormHelperService} from "../../services/person/form-helper-service";
import {User} from "../../types/security/user";
import {SecurityService} from "../../services/security/security.service";
import {ENTRY_STATES} from '../../types/entry/EntryStatesEnum';
import * as _ from 'lodash';

@Component({
  selector: 'wsd-add-custom-widget',
  templateUrl: './add-custom-widget-component.html',
  styleUrls: ['./add-custom-widget-component.css']
})
export class AddCustomWidgetComponent implements OnInit, OnDestroy {

  @Input()
  orderNumber: number;

  @Output()
  onDelete = new EventEmitter<CustomWidgetData>();

  @Output()
  onSave = new EventEmitter<CustomWidgetData>();

  display: boolean;

  ENTRY_STATES = ENTRY_STATES;

  widget: CustomWidgetData;

  userRolesOptions: SelectItem[] = [];
  sizeOptions: SelectItem[] = [];
  widgetForm: FormGroup;

  rawInput: boolean = false;

  user: User;

  private securitySubscription: Subscription;

  constructor(private userRoleRestService: UserRolesRestService,
              private addCustomWidgetService: AddCustomWidgetService,
              private fb: FormBuilder,
              private formHelper: FormHelperService,
              private translate: TranslateService,
              private securityService: SecurityService) {
  }

  ngOnInit() {
    this.initSize();
    this.userRoleRestService.getAllUserRoles(SystemType.DIRECTORY).subscribe(
      (userRoles: UserRole[]) => this.initUserRoles(userRoles)
    );
    this.securitySubscription = this.securityService.getLoggedUser().subscribe((user: User) => {
      this.user = user;
    });
    this.widgetForm = this.fb.group({
      title: ['', Validators.required],
      size: [1, Validators.required],
      roles: [[], Validators.required],
      content: ['', Validators.required]
    });
    this.addCustomWidgetService.messageSent$.subscribe(
      (widget: CustomWidgetData) => {
        this.initForm(widget);
        this.widgetForm.markAsPristine();
        this.display = true;
      }
    );
  }

  private initUserRoles(userRoles: UserRole[]) {
    this.userRolesOptions = [];
    for (const userRole of userRoles) {
      this.userRolesOptions.push({label: userRole.name, value: userRole});
    }
  }

  onRawInputChange() {
    if (this.rawInput == false) {
      this.rawInput = true;
    } else {
      this.rawInput = false;
    }
  }

  private initSize() {
    this.sizeOptions = [];
    for (let i = 1; i <= 4; i++) {
      this.sizeOptions.push({label: i.toString(), value: i});
    }
  }

  private initForm(data: CustomWidgetData) {
    this.widget = data;
    if(this.widget.id) {
      this.widgetForm.reset();
      this.widgetForm.get('title').setValue(this.widget.title);
      this.widgetForm.get('size').setValue(Number(this.widget.size));
      this.widgetForm.get('roles').setValue(this.widget.roles);
      this.widgetForm.get('content').setValue(this.widget.content);
    } else {
      this.widgetForm.reset();
      this.widgetForm.get('title').setValue(this.widget.title);
      this.widgetForm.get('size').setValue(Number(this.widget.size));
      this.widgetForm.get('content').setValue(this.widget.content);
      this.widgetForm.get('roles').setValue(this.userRolesOptions.map(item => item.value));
    }
  }

  save() {
    if(this.widget.orderNumber == undefined) {
      this.widget.orderNumber = this.orderNumber;
    }
    this.formHelper.validateAllFormFields(this.widgetForm);
    if (this.widgetForm.invalid) {
      return;
    }
    _.assign(this.widget, this.widgetForm.value);
    // this.widget.enteredBy = this.user;
    this.display = false;
    this.onSave.emit(this.widget);
    this.display = false;
  }

  ngOnDestroy() {
    this.securitySubscription.unsubscribe();
  }

}
